export const TOP_BANNER_VARIANTS = {
  SIGN_IN: "sign-in",
  PRO: "pro",
} as const;

export type TopBannerVariant =
  (typeof TOP_BANNER_VARIANTS)[keyof typeof TOP_BANNER_VARIANTS];

export const TOP_BANNER_BUTTON_TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
} as const;

export type TopBannerButtonType =
  (typeof TOP_BANNER_BUTTON_TYPES)[keyof typeof TOP_BANNER_BUTTON_TYPES];

export const TOP_BANNER_DEFAULTS = {
  DAYS_UNTIL_REDISPLAY: 7,
} as const;
